import { formFieldComponents } from '@/forms/components/FormListItemContainer';
import CatalogueLinksList from './components/CatalogueLinksList';
import CatalogueObjectsTable from './components/CatalogueObjectsTable';

export default {
  links: { editor: CatalogueLinksList, component: CatalogueLinksList, hasLabel: true },
  objects: { editor: CatalogueObjectsTable, component: CatalogueObjectsTable, hasLabel: true },
  ...formFieldComponents,
};
